import React, { FC, useCallback, useEffect, useState } from "react";
import MdaeTextBox from "../../common_components/common_widgets/text-box";
import MdaeSelectBox from "../../common_components/common_widgets/select-box";
import MdaeFileUploader from "../../common_components/common_widgets/file-uploader";
import {
  REMOVE_SELECTED_FILE,
  SAVE_DOCUMENT_UPLOAD_GRID_DATA,
  SET_DOCUMENT_DATA_TO_SAVE,
  SET_DOCUMENT_UPLOAD_PROGRESS,
  addCommonProperties,
  documentUploadDatagridKeyExpr,
  initialDocumentDataToSave,
} from "./reducers/document-management-reducer";
import { useDispatch, useSelector } from "react-redux";
import { DataGrid, Validator } from "devextreme-react";
import { CustomRule } from "devextreme-react/validator";
import { actions as asyncActions, callOperation } from "async-ops";
import { HIDE_LOADER, SHOW_LOADER } from "../mdae-common-reducer";
import { SAVE_USER_DOCUMENTS } from "./services/save-document";
import * as documentUploadFramework from "../../utils/document-upload-framework";
import mdaeNotfy, {
  NOTIFY_MESSAGE_TYPE,
} from "../../common_components/common_widgets/toast/notify";
import { GET_DOCUMENTS } from "./services/get-documents";
import { bindActionCreators } from "redux";
import MdaeCheckBox from "../common_widgets/check-box";
import { GET_DOCUMENT_MANAGEMENT_CONFIG } from "./services/get-document-management-configurations";
import { GET_USER_DOCUMENT_CATEGORY_LIST } from "./services/get-document-category-list";
import { logDocumentLifecycleEvent } from "./services/log-document-lifecycle-event";
import { initiateOCRPolling } from "../case-search/use-ocr-polling";
import {
  SET_CASE_SEARCH_DOCUMENT_DATA,
  SET_S3_OBJECT_NAME,
} from "../case-search/reducers/case-search-reducer";
import mdaeNotify from "../../common_components/common_widgets/toast/notify";
import dxFileUploader, { ValueChangedEvent } from "devextreme/ui/file_uploader";
import {
  Button,
  Column,
  Editing,
  Lookup,
  Pager,
  Paging,
  RequiredRule,
} from "devextreme-react/data-grid";
import dxDataGrid from "devextreme/ui/data_grid";
import { cloneDeep, first, isEqual } from "lodash";
import CircularProgressWithLabel from "../common_widgets/cIrcular-progress-indicator";
import { DOCUMENT_EVENT_TYPES, getReleventFileSizeUnitFromBytes, previewDocumentFromS3 } from "./component";
import { documentFieldValueChangeEvent, documentValidationGroup, documentValidationMessage, IEditDocumentPopup, isPopupCloseSafe, toggleEditDocumentPopupVisible } from "./edit-document-popup";
import { getFileExtension, getNumPages, isDocumentNameValid } from "./common-functions";
import { IMPORT_EHR_DOCUMENTATION } from "./services/import-ehr-documents";
export const DOCUMENT_POPUP_MODE = {
  UPLOAD: "UPLOAD",
  EDIT: "EDIT",
  OCR_UPLOAD: "OCR_UPLOAD",
};
const setUploadProgress = (
  dispatch,
  documentUploadDatagridKeyExpr,
  uploadProgress,
  uniqueId
) => {
  dispatch({
    type: SET_DOCUMENT_UPLOAD_PROGRESS,
    data: {
      documentUploadDatagridKeyExpr,
      uploadProgress,
      uniqueId
    },
  });
};
export const allowedFilesMap: any = {
  ".jpeg": "image/jpeg",
  ".jpg": "image/jpeg",
  ".png": "image/png",
  ".docx":
    "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
  ".doc": "application/msword",
  ".docm": "application/vnd.ms-word.document.macroEnabled.12",
  ".dot": "application/msword",
  ".dotm": "application/vnd.ms-word.template.macroEnabled.12",
  ".dotx":
    "application/vnd.openxmlformats-officedocument.wordprocessingml.template",
  ".rtf": "application/rtf",
  ".xml": "application/xml",
  ".wps": "application/vnd.ms-works",
  ".xps": "application/vnd.ms-xpsdocument",
  ".pdf": "application/pdf",
  ".xlsx": "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
  ".txt": "text/plain",
  ".xlsm": "application/vnd.ms-excel.sheet.macroEnabled.12",
  ".xlsb": "application/vnd.ms-excel.sheet.binary.macroEnabled.12",
  ".xltx":
    "application/vnd.openxmlformats-officedocument.spreadsheetml.template",
  ".xltm": "application/vnd.ms-excel.template.macroEnabled.12",
  ".xls": "application/vnd.ms-excel",
  ".xlt": "application/vnd.ms-excel",
  ".xlam": "application/vnd.ms-excel.addin.macroEnabled.12",
  ".xla": "application/vnd.ms-excel.addin",
  ".xlw": "application/vnd.ms-excel",
  ".xlr": "application/vnd.ms-works",
  ".csv": "text/csv",
  ".tiff": "image/tiff",
  ".tif": "image/tiff",
  ".html": "text/html",

};
export const EDIT_OR_ATTACH_COMPONENT_MODES = Object.freeze({
  MY_COMPUTER: "MY_COMPUTER",
  EHR: "EHR",
  DOCUMENT_LIBRARY: "DOCUMENT_LIBRARY",
});

export const PAYER_AUDIT_LEVEL_OPTIONS = [
  { code: "EA", displayName: "Payer Audit" },
  { code: "EAC", displayName: "Payer Audit Case" },
];

interface IEditOrAttachDocument extends IEditDocumentPopup {
  mode: keyof typeof EDIT_OR_ATTACH_COMPONENT_MODES;
  onDocumentUploaded?: (doc: { documentId: number; documentName: string; originalFileName: string; s3ObjectName: string; fileSize: number; attachedLevelName: string; attachedLevelId: number; documentCategoryId: number | null; documentCategoryName: string; }) => void;
  showLevelSelector?: boolean;
}


export const EditOrAttachDocument: FC<IEditOrAttachDocument> = (props) => {
  const { showLevelSelector } = props;
  let storeIdSuffix = "";
  const editDocumentPopupMode = useSelector(
    (state) => state["documentManagementReducer"].editDocumentPopupMode
  );
  if(editDocumentPopupMode !== DOCUMENT_POPUP_MODE.EDIT && editDocumentPopupMode !== DOCUMENT_POPUP_MODE.OCR_UPLOAD){
    storeIdSuffix = props.mode ?? "";
  }
  const dataSourceStoreId = props.uniqueId + storeIdSuffix;
  let allowedFilesMapCurrent = cloneDeep(allowedFilesMap);
  const [documentUploaderInstance, setDocumentUploaderInstance] = useState<
    dxFileUploader
  >(null);
  const [documentDataGridInstance, setDocumentDataGridInstance] = useState<
    dxDataGrid
  >(null);
  const dispatch = useDispatch();
  const asyncAction = bindActionCreators(
    {
      asyncOperationStart: asyncActions.asyncOperationStart,
    },
    dispatch
  );
  const ocrDocumentData = useSelector(
    (state: any) => state.caseSearchReducer.ocrDocumentData
  );
  const eaAuditId = useSelector(
    (state) => state["auditPropertiesReducer"]?.auditPropertiesData?.eaAuditId
  );
  const attachedLevelName = useSelector(
    (state) => state["documentManagementReducer"].attachedLevelName
  );
  const attachedLevelId = useSelector(
    (state) => state["documentManagementReducer"].attachedLevelId
  );
  const isPopupModeUploadToOCR = useSelector(
    (state: any) =>
      state.documentManagementReducer.editDocumentPopupMode ===
      DOCUMENT_POPUP_MODE.OCR_UPLOAD
  );
  if (isPopupModeUploadToOCR) allowedFilesMapCurrent = { ".pdf": "application/pdf" }; 
  const documentCategoryList = useSelector(
    (state) => state["documentManagementReducer"].documentCategoryList
  );
  const documentAttachmentLevelEnums = useSelector(
    (state) => state["documentManagementReducer"].documentAttachmentLevels
  );
  const currentSelectedRowData = useSelector((state) =>
    first<any>(state["documentManagementReducer"].documentDataToSaveStore[dataSourceStoreId])
  );
  const includeNonAuditLevelDocumentInd = useSelector(
    (state) =>
      state["documentManagementReducer"].includeNonAuditLevelDocumentInd
  );
  const taskAttachLevelEnums = useSelector(
    (state: any) => state["userTaskListReducer"].attachLevelEnums
  );

  const documentPopupMode = useSelector(
    (state: any) => state["documentManagementReducer"].documentPopupMode,
    isEqual
  );
  const clientId = useSelector(
    (state: any) => state["mdaeNavigationBarReducer"]?.currentUser?.clientId
  );

  const documentDataToSave: Array<typeof initialDocumentDataToSave> = useSelector(
    (state: any) => state["documentManagementReducer"].documentDataToSaveStore[dataSourceStoreId]
  );

  const isDocumentPopupSafeToClose: boolean = useSelector((state: any) =>
    isPopupCloseSafe(state, dataSourceStoreId)
  );

  const selectedRowsData = useSelector(
    (state: any) => state["documentManagementReducer"].selectedRowsData
  );
  const uploadDocumentCount = useSelector(
    (state: any) =>
      state["documentManagementReducer"].documentDataToSaveStore[dataSourceStoreId]?.length ?? 0
  );
  const selctedAttachItemCount =
    (selectedRowsData?.length ?? 0) + uploadDocumentCount;

  const totalDocumentSpaceAvailable = useSelector(
    (state) => state["documentManagementReducer"].totalDocumentSpaceAvailable
  );
  const getDocumentCategories = useCallback(() => {
    switch (attachedLevelName?.toUpperCase()) {
      case documentAttachmentLevelEnums.audit:
      case documentAttachmentLevelEnums.auditCase:
      case documentAttachmentLevelEnums.auditEntity:
        return documentCategoryList.internalWorkflowDocumentCategories;
      case documentAttachmentLevelEnums.externalAudit:
      case documentAttachmentLevelEnums.externalAuditCase:
      case documentAttachmentLevelEnums.externalAuditOCR:
      case "DL":
        return documentCategoryList.externalWorkflowDocumentCategories;
      case documentAttachmentLevelEnums.coder:
      case documentAttachmentLevelEnums.provider:
        return documentCategoryList.maintenanceWorkflowDocumentCategories;
      case documentAttachmentLevelEnums.task:
        return getDocumentCategoriesForTask(props.taskAttachmentLevel);
      default:
        return [];
    }
  }, [
    documentAttachmentLevelEnums,
    attachedLevelName,
    props.taskAttachmentLevel,
    documentCategoryList,
  ]);
  const getDocumentCategoriesForTask = useCallback(
    (taskAttachmentLevel) => {
      switch (taskAttachmentLevel?.toUpperCase()) {
        case taskAttachLevelEnums.audit:
        case taskAttachLevelEnums.auditCase:
        case taskAttachLevelEnums.auditEntity:
          return documentCategoryList.internalWorkflowDocumentCategories;
        case taskAttachLevelEnums.externalAudit:
        case taskAttachLevelEnums.externalAuditCase:
          return documentCategoryList.externalWorkflowDocumentCategories;
        case taskAttachLevelEnums.coder:
        case taskAttachLevelEnums.provider:
          return documentCategoryList.maintenanceWorkflowDocumentCategories;
        default:
          return [];
      }
    },
    [taskAttachLevelEnums, documentCategoryList]
  );

  useEffect(() => {
    if (!totalDocumentSpaceAvailable)
      asyncAction.asyncOperationStart(
        GET_DOCUMENT_MANAGEMENT_CONFIG,
        attachedLevelName
      );
    const isCategoryListEmpty =
      !documentCategoryList?.internalWorkflowDocumentCategories?.length &&
      !documentCategoryList?.externalWorkflowDocumentCategories?.length &&
      !documentCategoryList?.maintenanceWorkflowDocumentCategories?.length;
    if (isCategoryListEmpty)
      asyncAction.asyncOperationStart(GET_USER_DOCUMENT_CATEGORY_LIST);
  }, []);

  const onDocumentSelectionChange = useCallback(
    (
      e: ValueChangedEvent,
      documentDataToSave: Array<typeof initialDocumentDataToSave>
    ) => {
      let documentDataToSaveCopy =
        documentDataToSave != null ? [...documentDataToSave] : [];
      let getDocumentPromise = Promise.resolve<any>(null);
      if (e.value && e.value.length > 0) {
        e.value.forEach((file, index) => {
          let documentDataItemToSave = null;
          if (isPopupModeUploadToOCR)
            documentDataItemToSave = documentDataToSaveCopy[0];
          else
            documentDataItemToSave = documentDataToSaveCopy?.find(
              (x) => x.selectedFile === file
            );
          if (!documentDataItemToSave) {
            documentDataItemToSave = {
              ...initialDocumentDataToSave,
            };
            documentDataToSaveCopy.push(documentDataItemToSave);
          }

          documentDataItemToSave.documentName = file.name
            .split(".")
            .slice(0, -1)
            .join(".");
          documentDataItemToSave.selectedFile = file;
          documentDataItemToSave.originalFileName = file.name;
          documentDataItemToSave.fileSize = file.size;

          if (isPopupModeUploadToOCR) {
            getDocumentPromise = getNumPages(file);
            dispatch({ type: SHOW_LOADER });
          }

          getDocumentPromise = getDocumentPromise
            .then((pdfPageCount) => {
              //insert document page count
              if (pdfPageCount != null) {
                if (pdfPageCount > 100) {
                  mdaeNotify({
                    message: "Maximum PDF Page Size for OCR is 100 pages",
                    messageType: NOTIFY_MESSAGE_TYPE.ERROR,
                  });
                  documentUploaderInstance.reset();
                  return;
                }
                dispatch({
                  type: SET_CASE_SEARCH_DOCUMENT_DATA,
                  data: {
                    ocrDocumentData: {
                      ...documentDataItemToSave,
                      documentName: documentDataItemToSave.documentName,
                      pdfPageCount,
                    },
                  },
                });
              }
            })
            .catch((ex) => {
              mdaeNotify({
                message: "Please select a valid PDF document",
                messageType: NOTIFY_MESSAGE_TYPE.ERROR,
              });
              documentUploaderInstance.reset();
              first(documentDataToSaveCopy).selectedFile = null;
            })
            .finally(() => {
              dispatch({ type: HIDE_LOADER });
              setTimeout(() => {
                dispatch({ type: HIDE_LOADER });
              }, 1000);
            });
        });
        getDocumentPromise.then(() => {
          documentDataToSaveCopy.forEach((x) => addCommonProperties(x));
          dispatch({
            type: SET_DOCUMENT_DATA_TO_SAVE,
            data: { documentDataToSave: documentDataToSaveCopy, uniqueId: dataSourceStoreId },
          });
        });

        documentDataGridInstance?.refresh();
      } else {
        if (first(documentDataToSaveCopy)) {
          first(documentDataToSaveCopy).selectedFile = null;
          dispatch({
            type: SET_DOCUMENT_DATA_TO_SAVE,
            data: { documentDataToSave: documentDataToSaveCopy, uniqueId: dataSourceStoreId },
          });
        }
      }
    },
    [documentDataGridInstance, isPopupModeUploadToOCR, documentUploaderInstance, dataSourceStoreId]
  );

  const onDocumentNameChanged = useCallback(
    (e) => {
      if (isPopupModeUploadToOCR && e.event)
        dispatch({
          type: SET_CASE_SEARCH_DOCUMENT_DATA,
          data: {
            ocrDocumentData: {
              ...ocrDocumentData,
              documentName: e.value,
            },
          },
        });
    },
    [isPopupModeUploadToOCR, documentUploaderInstance, isPopupModeUploadToOCR]
  );

  const calculateFileSize = useCallback(
    (documentDataToSave: Array<typeof initialDocumentDataToSave>) => {
      return documentDataToSave?.reduce((sum, nextvalue) => {
        const fileSize = nextvalue.fileSize ?? nextvalue.selectedFile?.size;
        return (
          sum + (fileSize && nextvalue.uploadProgress !== 100 ? fileSize : 0)
        );
      }, 0);
    },
    []
  );
  const getFileSizeString = useCallback(() => {
    const fileSizeInBytes = calculateFileSize(documentDataToSave);
    const fileSizeInMB = fileSizeInBytes / (1024 * 1024);
    const fileSizeInKB = fileSizeInBytes / 1024;
    let fileSizeString = "";
    if (fileSizeInMB > 0 || fileSizeInKB > 0) {
      if (fileSizeInMB >= 1) {
        fileSizeString = Math.round(fileSizeInMB) + " MB";
      } else {
        if (fileSizeInKB >= 1) {
          fileSizeString = Math.round(fileSizeInKB) + " KB";
        } else {
          fileSizeString = Math.round(fileSizeInBytes) + " B";
        }
      }
    } else {
      fileSizeString = "0 KB";
    }
    return fileSizeString;
  }, [documentDataToSave]);
  const onDocumentUploaderInitialized = (e) => {
    setDocumentUploaderInstance(e.component);
  };

  const refreshDocumentList = useCallback(() => {
    asyncAction.asyncOperationStart(GET_DOCUMENTS, {
      attachedLevelId: attachedLevelId,
      attachedLevelName: attachedLevelName,
      showForCoderReviewInd: includeNonAuditLevelDocumentInd,
      isManagerView: attachedLevelName === "DL",
      uniqueId: props.uniqueId,
    });
  }, [attachedLevelId, attachedLevelName, includeNonAuditLevelDocumentInd, props.uniqueId]);

  const abortUpload = useCallback(
    (documentDataToSave) => {
      documentUploaderInstance.abortUpload(documentDataToSave.selectedFile);
      setUploadProgress(
        dispatch,
        documentDataToSave[documentUploadDatagridKeyExpr],
        -1,
        dataSourceStoreId
      );
    },
    [documentUploaderInstance]
  );

  const uploadDocument = useCallback(
    (documentDataToSave) => {
      return new Promise<void>((resolve, reject) => {
        documentDataToSave.attachedLevelId = attachedLevelId;
        if (!showLevelSelector) {
          documentDataToSave.attachedLevelName = attachedLevelName;
        }
        setUploadProgress(
          dispatch,
          documentDataToSave[documentUploadDatagridKeyExpr],
          0,
          dataSourceStoreId
        );
        let tags = null;
        if (isPopupModeUploadToOCR) {
          documentDataToSave.sendDocumentToOCR = true;
          if (!documentDataToSave.saveToDocumentManagement) {
            documentDataToSave.attachedLevelName =
              documentAttachmentLevelEnums.externalAuditOCR;
          }
          documentDataToSave.ocrMetricTrackingData = {
            pageCount: ocrDocumentData.pdfPageCount,
            eaAuditId,
          };

          // Add tags here
          tags = {
            clientId: clientId.toString(),
          };
        }
        dispatch({ type: SHOW_LOADER });
        callOperation(SAVE_USER_DOCUMENTS, documentDataToSave)
          .then(function(response) {
            dispatch({ type: HIDE_LOADER });
            if (response.isSaved) {
              setUploadProgress(
                dispatch,
                documentDataToSave[documentUploadDatagridKeyExpr],
                10,
                dataSourceStoreId
              );
              if (isPopupModeUploadToOCR)
                dispatch({
                  type: SET_CASE_SEARCH_DOCUMENT_DATA,
                  data: {
                    ocrDocumentData: {
                      ...ocrDocumentData,
                      documentId: response.documentId,
                      originalFileName:
                        documentDataToSave.originalFileName ||
                        documentDataToSave.documentName,
                      s3ObjectName: response.s3ObjectName,
                    },
                  },
                });
              const setUploadProgressWithDocumentKey = (value) => {
                setUploadProgress(
                  dispatch,
                  documentDataToSave[documentUploadDatagridKeyExpr],
                  value,
                  dataSourceStoreId
                );
              };
              documentUploadFramework
                .NewInstance()
                .uploadFile(
                  documentDataToSave.selectedFile,
                  response.s3ObjectName,
                  response.documentId,
                  documentDataToSave.documentName,
                  documentDataToSave.attachedLevelName,
                  documentDataToSave.attachedLevelId,
                  dispatch,
                  tags,
                  Boolean(isPopupModeUploadToOCR),
                  setUploadProgressWithDocumentKey
                )
                .then((isFileUploaded) => {
                  if (isFileUploaded) {
                    logDocumentLifecycleEvent(
                      response.documentId,
                      "DOCUMENT_UPLOADED",
                      "upload",
                      documentDataToSave.attachedLevelName,
                      documentDataToSave.attachedLevelId,
                    );
                    setUploadProgress(
                      dispatch,
                      documentDataToSave[documentUploadDatagridKeyExpr],
                      90,
                      dataSourceStoreId
                    );
                    setTimeout(() => {
                      setUploadProgress(
                        dispatch,
                        documentDataToSave[documentUploadDatagridKeyExpr],
                        100,
                        dataSourceStoreId
                      );
                    }, 500);
                    mdaeNotfy({
                      message:
                        documentDataToSave.documentName +
                        " uploaded Succesfully!",
                      messageType: NOTIFY_MESSAGE_TYPE.SUCCESS,
                    });
                    if (props.onDocumentUploaded) {
                      const categoryId = documentDataToSave.documentCategoryId ?? null;
                      const categoryName = (documentCategoryList?.externalWorkflowDocumentCategories ?? [])
                        .find((c) => c.documentCategoryId === categoryId)?.documentCategoryName ?? "";
                      props.onDocumentUploaded({
                        documentId: response.documentId,
                        documentName: documentDataToSave.documentName,
                        originalFileName: documentDataToSave.originalFileName,
                        s3ObjectName: response.s3ObjectName,
                        fileSize: documentDataToSave.fileSize,
                        attachedLevelName: documentDataToSave.attachedLevelName,
                        attachedLevelId: documentDataToSave.attachedLevelId,
                        documentCategoryId: categoryId,
                        documentCategoryName: categoryName,
                      });
                    }
                    resolve();
                    if (!props.doNotRefreshDataGrid) refreshDocumentList();

                    if (isPopupModeUploadToOCR) {
                      dispatch({
                        type: SET_S3_OBJECT_NAME,
                        data: response.s3ObjectName,
                      });
                      initiateOCRPolling(dispatch, asyncAction, {
                        s3ObjectName: response.s3ObjectName,
                      });
                    }
                  }
                  if (isPopupModeUploadToOCR)
                    toggleEditDocumentPopupVisible(dispatch, false, dataSourceStoreId);
                })
                .catch(() => {
                  dispatch({ type: HIDE_LOADER });
                  abortUpload(documentDataToSave);
                  reject();
                });
            }
            else{
              mdaeNotify({
                message: response.error,
                messageType: NOTIFY_MESSAGE_TYPE.ERROR,
              });
              dispatch({ type: HIDE_LOADER });
              abortUpload(documentDataToSave);
            }
          })
          .catch(() => {
            dispatch({ type: HIDE_LOADER });
            abortUpload(documentDataToSave);
            reject();
          });
      });
    },
    [
      isPopupModeUploadToOCR,
      documentAttachmentLevelEnums,
      ocrDocumentData,
      clientId,
      props.doNotRefreshDataGrid,
      includeNonAuditLevelDocumentInd,
      documentUploaderInstance,
      dataSourceStoreId,
      refreshDocumentList,
    ]
  );

  const validateSelectedDocumentToUpload = useCallback(
    (documentData: typeof initialDocumentDataToSave) => {
      let isUnsupportedFileExtension = false;
      let fileName = documentData.s3ObjectName;
      if (!fileName && documentData.selectedFile)
        fileName = documentData.selectedFile.name;
      const fileNameSplit = fileName.split(".");
      if (fileNameSplit.length === 1) isUnsupportedFileExtension = true;
      else {
        const fileExtension = "." + fileNameSplit[fileNameSplit.length - 1];
        if (
          !Object.keys(allowedFilesMapCurrent).includes(fileExtension?.toLowerCase())
        )
          isUnsupportedFileExtension = true;
      }
      if (isUnsupportedFileExtension) {
        return {
          isValidRow: false,
          warningIconTitle: "File Type not supported",
        };
      }
      let fileSize = documentData.fileSize;
      if (!fileSize && documentData.selectedFile)
        fileSize = documentData.selectedFile.size;
      const fileSizeInMB = fileSize / (1024 * 1024);
      const fileSizeLeft = Math.round(totalDocumentSpaceAvailable * 1024);
      if (fileSizeInMB > fileSizeLeft) {
        return {
          isValidRow: false,
          warningIconTitle:
            "Your organization only has " +
            getReleventFileSizeUnitFromBytes(fileSizeLeft * 1024 * 1024) +
            " of storage left. Your document is " +
            getReleventFileSizeUnitFromBytes(fileSize) +
            " and cannot be uploaded at this time.",
        };
      }

      if (fileSizeInMB > 500) {
        return {
          isValidRow: false,
          warningIconTitle: "File size can not be greater than 500 MB.",
        };
      }
      if (documentData.documentName != undefined) {
        if (!isDocumentNameValid(documentData.documentName)) {
          return {
            isValidRow: false,
            warningIconTitle:
              "This document contains invalid special characters. Please rename the document by removing the special characters or using one of the following: & $ @ = ! - _ . ) ( '",
          };
        }
      }
      return { isValidRow: true, warningIconTitle: "" };
    },
    [totalDocumentSpaceAvailable]
  );

  const uploadFileHandler = useCallback(
    (file, setUploadProgress) => {
      const currentDocumentDataToSave = documentDataToSave?.find(
        (x) => x.selectedFile === file
      );
      return uploadDocument(currentDocumentDataToSave);
    },
    [documentDataToSave, uploadDocument]
  );

  const onFileUploaderValueChanged = useCallback(
    (e) => {
      onDocumentSelectionChange(e, documentDataToSave);
    },
    [documentDataToSave, onDocumentSelectionChange]
  );

  const fileUploaderValidationcallback = useCallback(
    (e) => {
      if (
        e.value?.length === 0 ||
        first(documentDataToSave)?.selectedFile == null
      )
        return true;
      for (let index = 0; index < documentDataToSave.length; index++) {
        const documentDataItemToSave = documentDataToSave[index];
        const { isValidRow } = validateSelectedDocumentToUpload(
          documentDataItemToSave
        );
        if (!isValidRow) return false;
      }
      return true;
    },
    [documentDataToSave, validateSelectedDocumentToUpload]
  );

  const selctedDocumentsValidationcallback = useCallback(() => {
    return selctedAttachItemCount > 0;
  }, [selctedAttachItemCount]);

  const nameRequiredinMyComputerValidationCallaback = useCallback(() => {
    const documentDataToSaveCopy = first(documentDataToSave);
    let fileName = documentDataToSaveCopy?.s3ObjectName;
    if (!fileName && documentDataToSaveCopy?.selectedFile)
      fileName = documentDataToSaveCopy.selectedFile.name;
    if (uploadDocumentCount > 0 && fileName != null)
      return documentDataToSaveCopy?.documentName != null;
    else return true;
  }, [documentDataToSave, uploadDocumentCount]);

  const onDocumentDatagridRowRemoved = useCallback(
    (e) => {
      dispatch({
        type: REMOVE_SELECTED_FILE,
        data: {
          file: e.data.documentUploadDatagridKeyExpr,
        },
      });
      if(e.data.selectedFile){
        documentUploaderInstance.removeFile(e.data.selectedFile);
      }
    },
    [documentUploaderInstance]
  );

  const onDocumentDatagridSaving = useCallback((e: any) => {
    if (e.changes?.length > 0 && first<any>(e.changes)?.type === "insert") {
      e.changes.forEach((item) => {
        addCommonProperties(item.data);
      });
    } else if (
      e.changes?.length > 0 &&
      first<any>(e.changes)?.type === "update"
    ) {
      e.changes.forEach((item) => {
        item.data["updatedOn"] = new Date();
      });
    }
    dispatch({
      type: SAVE_DOCUMENT_UPLOAD_GRID_DATA,
      data: {
        change: e.changes[0],
        uniqueId: dataSourceStoreId
      },
    });
  }, [dataSourceStoreId]);
  const onDocumentDatagridInitialized = useCallback((e) => {
    setDocumentDataGridInstance(e.component);
  }, []);
  const onDocumentDatagridAllowUpdating = useCallback(({ row }) => {
    return row.data.uploadProgress === null || row.data.uploadProgress === -1;
  }, []);
  const onDocumentDatagridAllowDeleting = useCallback(({ row }) => {
    return (
      row.data.uploadProgress === null ||
      row.data.uploadProgress === 100 ||
      row.data.uploadProgress === -1
    );
  }, []);
  const onDocumentDatagridActionCellRender = useCallback(
    (e) => {
      const { isValidRow, warningIconTitle } = validateSelectedDocumentToUpload(
        e.data
      );
      if (!isValidRow) {
        return (
          <div style={{ marginLeft: 10 }}>
            <i
              className="dx-icon warning-red"
              title={warningIconTitle}
              style={{ height: 18 }}
            ></i>
          </div>
        );
      } else if (e.data.uploadProgress === -1)
        return (
          <div style={{ marginLeft: 10 }}>
            <i
              className="fa fa-refresh"
              title={"Upload failed, please hit Save to retry failed documents"}
              style={{ fontSize: 20, color: "#d41c1c" }}
            ></i>
          </div>
        );
      else if (e.data.uploadProgress !== null && e.data.uploadProgress !== 100)
        return (
          <div title="Upload in Progress">
            <CircularProgressWithLabel
              value={e.data.uploadProgress}
              width={30}
              height={30}
              fontSize={10}
            />
          </div>
        );
      else if (e.data.uploadProgress === 100)
        return (
          <div style={{ marginLeft: 10 }}>
            <i
              className="fa fa-check-circle"
              title={"Upload Complete"}
              style={{ color: "green", fontSize: 20 }}
            ></i>
          </div>
        );
      else return <></>;
    },
    [validateSelectedDocumentToUpload]
  );


  const documentFieldValueChangeHandler = useCallback((e) => {
    documentFieldValueChangeEvent(
      dispatch,
      e.component.option("name"),
      e.value,
      dataSourceStoreId
    );
  }, [dataSourceStoreId]);
  return (
    <>
      {" "}
      {[DOCUMENT_POPUP_MODE.UPLOAD, DOCUMENT_POPUP_MODE.OCR_UPLOAD].includes(
        documentPopupMode,
      ) && (
        <div style={{ display: "flex", position: "relative" }}>
          <MdaeFileUploader
            id={"btnFileUploader_" + props.mode}
            disabled={!isDocumentPopupSafeToClose}
            visible={
              [
                DOCUMENT_POPUP_MODE.UPLOAD,
                DOCUMENT_POPUP_MODE.OCR_UPLOAD,
              ].includes(documentPopupMode) &&
              props.mode === EDIT_OR_ATTACH_COMPONENT_MODES.MY_COMPUTER
            }
            multiple={!isPopupModeUploadToOCR}
            showFileList={isPopupModeUploadToOCR}
            maxFileSize={524288000}
            onValueChanged={onFileUploaderValueChanged}
            uploadFile={uploadFileHandler}
            abortUpload={() => Promise.resolve()}
            onInitialized={onDocumentUploaderInitialized}
            defaultValue={[]}
            allowedFileExtensions={Object.keys(allowedFilesMapCurrent)}
            accept={Object.values(allowedFilesMapCurrent).join(",")}
          >
            <Validator validationGroup={documentValidationGroup}>
              <CustomRule
                message={""}
                reevaluate={true}
                validationCallback={fileUploaderValidationcallback}
              />
              <CustomRule
                validationCallback={selctedDocumentsValidationcallback}
                reevaluate={true}
                message={""}
              />
            </Validator>
          </MdaeFileUploader>

          <div>
            <label
              id="file-size-limit"
              style={{
                color:
                  documentDataToSave?.reduce(
                    (sum, nextvalue: any) =>
                      sum + parseFloat(nextvalue.fileSize),
                    0,
                  ) /
                    (1024 * 1024) >
                  500
                    ? "red"
                    : "green",
                width: "150px",
                marginTop: "20px",
                position: "absolute",
                right: "-15px",
              }}
            >
              {getFileSizeString()} of 500 MB
            </label>
          </div>
        </div>
      )}
      {[DOCUMENT_POPUP_MODE.UPLOAD].includes(documentPopupMode) && (
        <div
          style={{
            marginTop:
              props.mode === EDIT_OR_ATTACH_COMPONENT_MODES.EHR ? 45 : 0,
          }}
        >
          <DataGrid
            id={"grdDocumentUpload_" + props.mode}
            keyExpr={documentUploadDatagridKeyExpr}
            dataSource={documentDataToSave}
            onRowRemoved={onDocumentDatagridRowRemoved}
            onSaving={onDocumentDatagridSaving}
            onInitialized={onDocumentDatagridInitialized}
          >
            <Editing
              mode="cell"
              allowUpdating={onDocumentDatagridAllowUpdating}
              allowDeleting={onDocumentDatagridAllowDeleting}
              allowAdding={false}
              confirmDelete={false}
            />
            <Paging defaultPageSize={5} />
            <Pager
              showPageSizeSelector={true}
              showNavigationButtons={true}
              allowedPageSizes={[5, 10]}
              showInfo={true}
            />
            <Column width={40} type="buttons" visibleIndex={0}>
              <Button name="delete" cssClass={"delete-action-icon"} />
            </Column>
            <Column
              allowSorting={false}
              allowFiltering={false}
              fixed={true}
              allowEditing={false}
              allowExporting={false}
              allowResizing={false}
              allowReordering={false}
              alignment="center"
              cssClass="document-upload-validation-column-max-width"
              cellRender={onDocumentDatagridActionCellRender}
              name={"documentUploadValidationColumn"}
            ></Column>
            {getDocumentPreviewColumn(
              asyncAction,
              attachedLevelId,
              attachedLevelName,
              dispatch,
            )}
            <Column
              caption={"File Name"}
              dataField={"documentName"}
              showEditorAlways={true}
            ></Column>
            <Column
              editorOptions={{ placeholder: "Choose a Category" }}
              caption={"Category"}
              dataField={"documentCategoryId"}
              showEditorAlways={true}
            >
              <Lookup
                displayExpr={"documentCategoryName"}
                valueExpr={"documentCategoryId"}
                dataSource={getDocumentCategories()}
              />
            </Column>
            {showLevelSelector && (
              <Column
                editorOptions={{ placeholder: "Choose a Level" }}
                caption={"Level *"}
                dataField={"attachedLevelName"}
                showEditorAlways={true}
              >
                <Lookup
                  displayExpr={"displayName"}
                  valueExpr={"code"}
                  dataSource={PAYER_AUDIT_LEVEL_OPTIONS}
                />
                <RequiredRule message="Level is required" />
              </Column>
            )}
            <Column
              width={70}
              caption={"File Type"}
              calculateDisplayValue={(e) => {
                let fileName = "";
                if (e.s3ObjectName) {
                  fileName = e.s3ObjectName;
                } else {
                  fileName = e.selectedFile?.name;
                }
                return getFileExtension(fileName);
              }}
            ></Column>
            <Column
              width={80}
              caption={"File Size"}
              allowEditing={false}
              calculateDisplayValue={(e) => {
                const fileSize = e.fileSize ?? e.selectedFile?.size;
                return getReleventFileSizeUnitFromBytes(fileSize);
              }}
            ></Column>
          </DataGrid>
        </div>
      )}
      {[DOCUMENT_POPUP_MODE.EDIT, DOCUMENT_POPUP_MODE.OCR_UPLOAD].includes(
        documentPopupMode,
      ) && (
        <>
          <div>
            <MdaeCheckBox
              id="chkSaveToDocumentManagement"
              visible={isPopupModeUploadToOCR && !props.hideSaveToDocumentManagementCheckbox}
              value={first(documentDataToSave)?.saveToDocumentManagement}
              onValueChanged={documentFieldValueChangeHandler}
              name={"saveToDocumentManagement"}
              text="Upload to Audit Level Document Management"
            />
          </div>
          <div className={"widget-separation-margin-top"}>
            <MdaeTextBox
              required
              id={"txtDocumentName"}
              mdaeTextBoxTitle={"File Name"}
              disabled={currentSelectedRowData?.isDocInEsmdSubmission}
              value={first(documentDataToSave)?.documentName}
              onValueChanged={(e) => {
                if (e.event) {
                  onDocumentNameChanged(e);
                  documentFieldValueChangeHandler(e);
                }
              }}
              name={"documentName"}
            >
              <Validator validationGroup="documentValidationGroup">
                <CustomRule
                  message={"Name is required"}
                  reevaluate={true}
                  validationCallback={
                    nameRequiredinMyComputerValidationCallaback
                  }
                />
                <CustomRule
                  validationCallback={(e) => isDocumentNameValid(e.value)}
                  message={documentValidationMessage}
                />
              </Validator>
            </MdaeTextBox>
          </div>
          <div className={"widget-separation-margin-top"}>
            <MdaeSelectBox
              id={"ddlDocumentCategory"}
              mdaeDropDownBoxTitle={"Category"}
              displayExpr={"documentCategoryName"}
              valueExpr={"documentCategoryId"}
              dataSource={getDocumentCategories()}
              value={first(documentDataToSave)?.documentCategoryId}
              name={"documentCategoryId"}
              onValueChanged={documentFieldValueChangeHandler}
            ></MdaeSelectBox>
          </div>
        </>
      )}
    </>
  );
};

const getDocumentPreviewColumn = (
  asyncAction: any,
  attachedLevelId: string | number,
  attachedLevelName: string,
  dispatch: any,
) => {
  const onDocumentDatagriPreviewCellRender = (e) => {
    const onPreviewIconClick = () => {
      const onOpenFileInNewTab = async (file: File) => {
        // Read file as Blob
        const fileURL = URL.createObjectURL(file);
        window.open(fileURL, "_blank");
      };
      const currentSelectedRowData = e.data;
      if (currentSelectedRowData.selectedFile)
        onOpenFileInNewTab(currentSelectedRowData.selectedFile);
      else if (currentSelectedRowData.s3ObjectName) {
        previewDocumentFromS3(
          dispatch,
          asyncAction,
          currentSelectedRowData.s3ObjectName,
          currentSelectedRowData.documentName,
          currentSelectedRowData.documentName,
          currentSelectedRowData.documentId ?? 9,
          attachedLevelId,
          attachedLevelName,
          DOCUMENT_EVENT_TYPES.NON_UPLOADED_DOCUMENT
        );
      } else if (
        currentSelectedRowData.binaryId &&
        currentSelectedRowData.contentType
      ) {
        dispatch({ type: SHOW_LOADER });
        const importEhrObject = {
          binaryId: currentSelectedRowData.binaryId,
          contentType: currentSelectedRowData.contentType,
        };
        callOperation(IMPORT_EHR_DOCUMENTATION, {
          ehrDocumentReadInformation: [importEhrObject],
        }).then((response) => {
          const readFileInfo = first<any>(response);
          const s3ObjectName = readFileInfo.key;
          const documentName = readFileInfo.binaryId;
          previewDocumentFromS3(
            dispatch,
            asyncAction,
            s3ObjectName,
            documentName,
            documentName,
            currentSelectedRowData.documentId ?? 9,
            attachedLevelId,
            attachedLevelName,
            DOCUMENT_EVENT_TYPES.NON_UPLOADED_DOCUMENT
          )
        }).catch(() =>{
          mdaeNotify({
            message: "Unable to preview document",
            messageType: NOTIFY_MESSAGE_TYPE.ERROR,
          });
          dispatch({ type: HIDE_LOADER });
        })
      }
    };
    return (
      <div
        style={{ height: "14px", cursor: "pointer" }}
        className="preview-action-icon"
        onClick={onPreviewIconClick}
      ></div>
    );
  };
  return (
    <Column
      allowSorting={false}
      allowFiltering={false}
      fixed={true}
      allowEditing={false}
      allowExporting={false}
      allowResizing={false}
      allowReordering={false}
      alignment="center"
      cssClass="document-upload-preview-column-max-width"
      cellRender={onDocumentDatagriPreviewCellRender}
      name={"documentUploadPreviewFileColumn"}
    />
  );
};

export default getDocumentPreviewColumn;